module.exports = __webpack_public_path__ + "static/media/search--white.4ab3d841.svg";